/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IFormField } from 'apmui/components/form/Model';
import Resolvable from 'apmui/util/Resolvable';
import { IWebtopResourceModel } from 'apmui/resource';

enum CommonDialogAction {
    OK = 'ok_action',
    CANCEL = 'cancel_action',
    UPDATE = 'update_action',
    EXPAND = 'expand_action',
}

enum DialogClass {
    APPLICATION_TUNNEL = 'APPLICATION_TUNNEL',
    ENDPOINT_SECURITY = 'ENDPOINT_SECURITY',
    NETWORK_ACCESS = 'NETWORK_ACCESS',
    TIMEOUT = 'TIMEOUT',
    MESSAGE = 'MESSAGE',
    VDI = 'VDI',
}

enum DialogType {
    APPTUN_AUTO_START_NOT_SUPPORTED = 'sapptun_auto_start_not_supported',
    APPTUN_FAILED_TO_START = 'sapptun_failed_to_start',
    APPTUN_INSTALL = 'sapptun_install',
    APPTUN_POPUP_BLOCKED = 'sapptun_popup_blocked',
    EPS_AUTO_START_NOT_SUPPORTED = 'sepc_auto_start_not_supported',
    EPS_FAILED_TO_PARSE_STATUS_UPDATE = 'sepc_failed_to_parse_status_update',
    EPS_FAILED_TO_RETRIEVE_STATUS_UPDATE = 'sepc_failed_to_retrieve_status_update',
    EPS_INSPECTION_HOST_NOT_CONNECTED = 'sepc_inspection_host_not_connected',
    EPS_INSTALL = 'sepc_install',
    EPS_POPUP_BLOCKED = 'sepc_popup_blocked',
    NA_AUTO_START_NOT_SUPPORTED = 'sna_auto_start_not_supported',
    NA_FAILED_TO_START = 'sna_failed_to_start',
    NA_INSTALL = 'sna_install',
    NA_POPUP_BLOCKED = 'sna_popup_blocked',
    SESSION_TIMEOUT = 'session_timeout',
    VDI_SETTINGS = 'vdi_settings',
    VDI_LAUNCH_CLIENT = 'vdi_launch_client',
    VDI_LOGON = 'vdi_logon',
    VDI_ERROR = 'vdi_error',
    VDI_DESTINATION = 'vdi_destination',
}

enum DialogPriority {
    HIGH_PRIORITY = 0,
    NORMAL_PRIORITY = 1,
    LOW_PRIORITY = 2,
}

interface IDialogAction {
    id: string;
    hidden?: boolean;
    caption: string;
    description?: string;
    style?: string;
    url?: string;
}

interface IDialogActionEventDetail {
    action: string;
    dialog: IDialogConfiguration;
    field?: string;
    value?: string | boolean;
}

type IDialogOpenEventDetail = {
    callback?: Resolvable;
    dialog: string | IDialogConfiguration;
} & Record<string, any>;

interface IDialogCloseEventDetail {
    dialog: DialogClass | IDialogConfiguration;
    resolve?: boolean | string;
}

interface IDialogText {
    id: string;
    text: string;
}

type IDialogEntry = IFormField | IDialogAction | IDialogText;

interface IDialogConfiguration {
    id: DialogType;
    class: DialogClass;
    title: string;
    body?: string;
    callback?: Resolvable;
    entries?: IDialogEntry[];
    showCloseButton?: boolean;
    showCopyright?: boolean;
    priority?: DialogPriority;
    resource?: IWebtopResourceModel;
    closeTitle?: string;
}

type DialogStack = IDialogConfiguration[];

export {
    CommonDialogAction,
    IDialogAction,
    IDialogActionEventDetail,
    IDialogOpenEventDetail,
    IDialogCloseEventDetail,
    IDialogText,
    IDialogEntry,
    DialogClass,
    DialogType,
    DialogPriority,
    DialogStack,
    IDialogConfiguration,
    IDialogConfiguration as default,
};
